<template>
  <div>
    <button
      class="btn btn--outline border-gray-800 text-gray-800 md:hidden flex items-center justify-center gap-2"
      type="button"
      @click="openMenu"
    >
      <IconAdjustmentsHorizontal :aria-hidden="true" />
      <span v-text="'Filter'" />
      <span
        class="sr-only"
        v-text="' Search Results'"
      />
    </button>
  </div>

  <Dialog
    :initial-focus="mobileFilterMenuTitleRef"
    :open="dialogOpen"
    :unmount="false"
    as="div"
    class="relative z-50 lg:hidden"
    @close="closeMenu"
  >
    <transition
      enter-active-class="ease-in-out duration-500 motion-reduce:transition-none"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in-out duration-500 motion-reduce:transition-none"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      @after-leave="dialogOpen = false"
    >
      <div
        v-show="menuOpen"
        class="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
    </transition>

    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
          <transition
            enter-active-class="transition-transform ease-out duration-300 motion-reduce:hover:transform-none"
            enter-from-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition-transform ease-in duration-300 motion-reduce:hover:transform-none"
            leave-from-class="translate-x-0"
            leave-to-class="-translate-x-full"
          >
            <DialogPanel
              v-show="menuOpen"
              class="pointer-events-auto w-screen max-w-md"
            >
              <div class="flex h-full flex-col overflow-y-auto bg-white pb-6 shadow-sm">
                <div class="flex justify-between items-center border-b border-b-gray-300">
                  <DialogTitle
                    ref="mobileFilterMenuTitleRef"
                    class="heading-sm pl-4"
                    tabindex="-1"
                    v-text="'Filters'"
                  />
                  <button
                    class="wc-focus relative flex size-12 items-center justify-center rounded-full focus-visible:outline-offset-1"
                    type="button"
                    @click="menuOpen = false"
                  >
                    <span class="absolute inset-px" />
                    <span
                      class="sr-only"
                      v-text="'Close Search Filters Menu'"
                    />
                    <IconX
                      :size="24"
                      aria-hidden="true"
                    />
                  </button>
                </div>

                <BaseSearchFilters
                  :attribute="attribute"
                  :subheading-text="subheadingText"
                  @apply-filters="menuOpen = false"
                />
              </div>
            </DialogPanel>
          </transition>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue'
import { IconAdjustmentsHorizontal, IconX } from '@tabler/icons-vue'

import BaseSearchFilters from '@js/components/search/BaseSearchFilters.vue'

defineOptions({
  name: 'BaseMobileSearchFilters',
})

defineProps<{
  attribute: string
  subheadingText: string
}>()

const menuOpen = ref(false)
const dialogOpen = ref(false)
const mobileFilterMenuTitleRef = ref<HTMLHeadingElement | null>(null)

const openMenu = (): void => {
  menuOpen.value = true
  dialogOpen.value = true
}

const closeMenu = (): void => {
  menuOpen.value = false
}
</script>
